var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAvailableTech(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46738 7.90189C4.46738 7.90189 3.90381 8.62015 3.115 8.99671C2.32618 9.37327 1.53566 9.15396 1.48466 8.47395C1.43366 7.79393 2.50469 7.31452 3.51621 7.56018C4.52773 7.80583 6.24647 8.8046 7.02253 9.17521C7.7986 9.54582 8.87302 9.73027 9.76639 8.8352C10.6598 7.94014 11.5208 7.24737 11.5208 7.24737",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7168 7.92314L4.58986 5.33483C5.34042 5.02373 6.51855 5.27023 7.81227 5.75984C9.106 6.24945 11.4878 7.77863 14.3081 7.36467C14.3081 7.36467 14.6983 5.26938 13.7522 3.29054C12.8979 1.5055 10.7771 0.675883 8.51269 1.11619C4.6587 1.86676 4.58986 5.33313 4.58986 5.33313",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1949 8.24189C5.1949 8.24189 3.84082 13.2349 6.96379 14.283C8.70378 14.8669 10.3953 13.7092 11.4289 12.7019",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1051 10.5794C12.9141 12.4713 13.0196 14.3813 13.4179 16.2406C13.4179 16.2406 9.67784 18.5866 6.54297 16.3613C6.54297 16.3613 7.08528 16.0017 6.96203 14.283",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75439 17.3175C9.75439 17.3175 11.1289 18.1948 11.0507 20.5289C11.0507 20.5289 13.4367 19.9016 14.7057 18.0928C15.4954 16.9673 13.4188 16.2406 13.4188 16.2406",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54284 16.3613C6.54284 16.3613 4.853 16.4556 5.02216 17.6159C5.22701 19.0184 7.05625 20.2509 7.05625 20.2509C6.71625 18.3053 8.42648 17.1909 8.42648 17.1909",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87948 17.6771L2.57933 18.9453C2.09748 19.2353 1.69883 19.645 1.4221 20.1346C1.14536 20.6241 0.999956 21.177 1 21.7393V25H18.8869V21.7053C18.8875 21.1522 18.7474 20.6081 18.4797 20.1241C18.212 19.6401 17.8257 19.2321 17.3569 18.9385L15.0049 17.4714",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8707 10.1961C13.4037 10.3873 14.0268 10.0108 14.2614 9.35457C14.496 8.69835 14.2554 8.01154 13.7225 7.82453C13.3893 7.70553 13.0212 7.80753 12.7339 8.06169",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9624 8C18.9487 8 17.9765 8.4027 17.2597 9.11952C16.5428 9.83634 16.1401 10.8086 16.1401 11.8223C16.1401 14.5238 19.4299 17.2597 19.9624 17.2597C20.5683 17.2597 23.7847 14.4067 23.7847 11.8223C23.7848 11.3203 23.6861 10.8232 23.494 10.3594C23.302 9.89562 23.0204 9.47421 22.6655 9.11925C22.3105 8.76429 21.8891 8.48275 21.4253 8.29071C20.9615 8.09866 20.4644 7.99988 19.9624 8ZM20.0721 13.378C19.7851 13.3782 19.5046 13.2932 19.2659 13.1339C19.0272 12.9746 18.8411 12.7482 18.7312 12.4831C18.6212 12.218 18.5924 11.9263 18.6482 11.6449C18.7041 11.3634 18.8422 11.1048 19.0451 10.9019C19.2479 10.6989 19.5064 10.5606 19.7878 10.5046C20.0692 10.4485 20.361 10.4772 20.6261 10.587C20.8912 10.6967 21.1178 10.8827 21.2773 11.1213C21.4367 11.3598 21.5218 11.6403 21.5218 11.9273C21.5213 12.3115 21.3684 12.6797 21.0965 12.9512C20.8247 13.2227 20.4563 13.3752 20.0721 13.3752V13.378Z",
    fill: "#6ACEA5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2364 8C19.2226 8 18.2504 8.4027 17.5336 9.11952C16.8168 9.83634 16.4141 10.8086 16.4141 11.8223C16.4141 14.5238 19.7039 17.2597 20.2364 17.2597C20.8423 17.2597 24.0586 14.4067 24.0586 11.8223C24.0588 11.3203 23.96 10.8232 23.7679 10.3594C23.5759 9.89562 23.2943 9.47421 22.9394 9.11925C22.5844 8.76429 22.163 8.48275 21.6992 8.29071C21.2354 8.09866 20.7383 7.99988 20.2364 8V8ZM20.346 13.378C20.0591 13.3782 19.7785 13.2932 19.5398 13.1339C19.3011 12.9746 19.115 12.7482 19.0051 12.4831C18.8952 12.218 18.8663 11.9263 18.9222 11.6449C18.978 11.3634 19.1161 11.1048 19.319 10.9019C19.5218 10.6989 19.7803 10.5606 20.0617 10.5046C20.3432 10.4485 20.6349 10.4772 20.9 10.587C21.1651 10.6967 21.3918 10.8827 21.5512 11.1213C21.7106 11.3598 21.7957 11.6403 21.7957 11.9273C21.7953 12.3115 21.6423 12.6797 21.3705 12.9512C21.0986 13.2227 20.7302 13.3752 20.346 13.3752V13.378Z",
    stroke: "#003A5E",
    strokeWidth: 1.63994,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96393 21.2004C9.201 21.2004 9.39319 21.0082 9.39319 20.7712C9.39319 20.5341 9.201 20.3419 8.96393 20.3419C8.72685 20.3419 8.53467 20.5341 8.53467 20.7712C8.53467 21.0082 8.72685 21.2004 8.96393 21.2004Z",
    fill: "#003A5E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96393 23.5159C9.201 23.5159 9.39319 23.3237 9.39319 23.0866C9.39319 22.8495 9.201 22.6573 8.96393 22.6573C8.72685 22.6573 8.53467 22.8495 8.53467 23.0866C8.53467 23.3237 8.72685 23.5159 8.96393 23.5159Z",
    fill: "#003A5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvailableTech);
export default __webpack_public_path__ + "static/media/ic-available-tech.343bddbd.svg";
export { ForwardRef as ReactComponent };